import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

const lang = window.localStorage.getItem('language') || 'vi'
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: lang,
    lng: lang,
    debug: false,
    interpolation: {
      escapeValue: false
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    react: {
      useSuspense: false
    }
  })

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng).then(() => {
    window.localStorage.setItem('language', lng)
  })
}

export default i18n
